import { InjectionToken } from '@angular/core';

export type Loglevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'off';

export interface LibConfig {
  backendHost: string;
  entgeltatlasHost: string;
  sucheMitBildungszielen: boolean;
  showLadeanimation: boolean;
  showOrtsunabhaengig: boolean;
  showThemenfelder?: boolean; // default false
  showFeedbackComponent?: boolean;
  showHeader?: boolean;
  showBefragungBanner?: boolean;
  nowPortalBasePath?: string;
  baBasePath?: string;
  newPlanBasePath?: string;
  logLevel: Loglevel;
  // Gibt an ob die Lib innerhalb der NowWbSuche oder in einer anderen Anwendung verwendet wird
  // (Steuert dadurch z.B. das Erstellen von router links)
  isNowWbSuche?: boolean;
  geois: {
    geoisGeocodeServer: string;
    geoisStylesheetUrl: string;
    geoisScriptUrl: string;
    geoisImageServer: string;
  };
  oiam: {
    clientId: string;
    redirecturi: string;
    logouturi: string;
    metadataUrl?: string;
    oiamOauthWcUrl: string;
  };
}

export const LIB_CONFIG = new InjectionToken<LibConfig>(
  'LIB_CONFIG: Konfiguration für die SucheLib'
);
